// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1278":"1522eb4a","5944":"4458d4e1","6890":"96a633ca"}[chunkId] + ".chunk.css";
};